import React from 'react';
import Header from './components/sections/Header';
import Hero from './components/sections/Hero';
import About from './components/sections/About';
import Services from './components/sections/Services';
import Gallery from './components/sections/Gallery';
import Contact from './components/sections/Contact';
import Footer from './components/sections/Footer';
import LayoutTakeover from './components/LayoutTakeover';

import './App.css';


const App: React.FC = () => {
  return (
    <div className="App">
            <Header />
        <LayoutTakeover>
    
          <Hero />
          <Services />
          <About />
          <Gallery />
          <Contact />
     
       </LayoutTakeover>
           <Footer />
    </div>
  );
};

export default App;